import { render, staticRenderFns } from "./registerSoUserMobile.vue?vue&type=template&id=4c77c9cc"
import script from "./registerSoUserMobile.vue?vue&type=script&lang=js"
export * from "./registerSoUserMobile.vue?vue&type=script&lang=js"
import style0 from "./registerSoUserMobile.vue?vue&type=style&index=0&id=4c77c9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports